var React = require('react');

function IconMediumInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5,0C7.387,0,0,7.387,0,16.5C0,25.613,7.387,33,16.5,33C25.613,33,33,25.613,33,16.5C33,7.387,25.613,0,16.5,0z\r\n\t M26.167,11.323h-0.732c-0.273,0-0.657,0.393-0.657,0.645v9.114c0,0.252,0.384,0.594,0.657,0.594h0.732v2.164h-6.645v-2.164h1.392\r\n\tv-9.58h-0.068L17.598,23.84h-2.514l-3.206-11.744h-0.081v9.58h1.391v2.164H7.625v-2.164h0.712c0.293,0,0.679-0.342,0.679-0.594\r\n\tv-9.114c0-0.252-0.385-0.645-0.679-0.645H7.625V9.16h6.956l2.284,8.499h0.062l2.305-8.499h6.935V11.323z"}));
}

IconMediumInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"33px","height":"33px","viewBox":"0 0 33 33","enableBackground":"new 0 0 33 33","xmlSpace":"preserve"};

module.exports = IconMediumInline;

IconMediumInline.default = IconMediumInline;
